import { RoundtripOffer } from './der-tailormade-roundtrip-offer.component';

export * from './der-tailormade-roundtrip-offer.component';
export default RoundtripOffer;

RoundtripOffer.define('der-tailormade-roundtrip-offer');

declare global {
    interface HTMLElementTagNameMap {
        'der-tailormade-roundtrip-offer': RoundtripOffer;
    }
}
